import { IApplicationError } from "./IApplicationError";

let errors: string[];
let hasError = false;

export class ApplicationError implements IApplicationError {
  public addError(value: string): void {
    errors.push(value);
  }
  public getErrors(): string[] {
    return errors;
  }
  public setHasError(value: boolean): void {
    hasError = value;
  }
  public hasError(): boolean {
    return hasError;
  }
}
